import styled from 'styled-components';
// import palette from '../../../lib/styles/palette';
// import { useSelector } from 'react-redux';
import { useEffect, useState } from 'react';
import DriveComponentSingle from './DriveComponentSingle';
import DriveComponentDual from './DriveComponentDual';
import DriveComponentTriple from './DriveComponentTriple';

const DriveComponentSelectionForm = ({
    drives,
    resistance,
    pulleys,
    fluidCouplings,
    gearCouplings,
    reducers,
    brakes,
    backstops,
}) => {
    const [, setDriveType] = useState('');

    /* drive(s) 수량을 체크하여 폼 선택 */
    useEffect(() => {
        if (!drives || !Array.isArray(drives)) return;

        setDriveType(drives.length === 1 ? 'single' : drives.length === 2 ? 'dual' : 'triple');
    }, [drives]);

    return (
        <Wrapper>
            <Title>
                <h3>Drive Component</h3>
            </Title>
            <Content>
                <Spacer />
                {drives.length === 1 && (
                    <DriveComponentSingle
                        drives={drives}
                        resistance={resistance}
                        pulleys={pulleys}
                        fluidCouplings={fluidCouplings}
                        gearCouplings={gearCouplings}
                        reducers={reducers}
                        brakes={brakes}
                        backstops={backstops}
                    />
                )}
                {drives.length === 2 && (
                    <DriveComponentDual
                        drives={drives}
                        resistance={resistance}
                        pulleys={pulleys}
                        fluidCouplings={fluidCouplings}
                        gearCouplings={gearCouplings}
                        reducers={reducers}
                        brakes={brakes}
                        backstops={backstops}
                    />
                )}
                {drives.length === 3 && (
                    <DriveComponentTriple
                        drives={drives}
                        resistance={resistance}
                        pulleys={pulleys}
                        fluidCouplings={fluidCouplings}
                        gearCouplings={gearCouplings}
                        reducers={reducers}
                        brakes={brakes}
                        backstops={backstops}
                    />
                )}
            </Content>
        </Wrapper>
    );
};

export default DriveComponentSelectionForm;

const Wrapper = styled.div``;
const Title = styled.div``;
const Content = styled.div``;

// const DriveComponentSelectionFormBlock = styled.div`
//     // background-color: yellow;
//     width: 100%;
//     max-width: 1000px;
//     // margin: 0 auto;
//     margin-top: 2rem;
//     td {
//         padding: 0.125rem 0.5rem;
//         // border: 1px solid;
//     }
// `;

// const Table = styled.div`
//     width: 100%;
//     border-collapse: collapse;
//     .tr-hover-effect {
//         &:hover {
//             background-color: ${palette.gray[1]};
//             transition: 0.3s;
//         }
//     }
// `;

const Spacer = styled.div`
    margin-bottom: 1rem;
`;
